import { INVALID_PATH } from 'utils/urlPaths'
import onboardingRoutesMap from 'routing/routesMap/onboarding'
import clientRoutesMap from 'routing/routesMap/client'

export default {
  ...onboardingRoutesMap,
  ...clientRoutesMap,
  ERROR_PAGE: INVALID_PATH
}



// WEBPACK FOOTER //
// ./src/routing/routesMap/index.js